import {BaseAppModel} from "./AppModel";
import {MessageLevel} from "./Message";

export enum DeviceMessageType {
    BIND = "BIND", UNBIND = "UNBIND",
    ONLINE = "ONLINE", OFFLINE = "OFFLINE",
    SHARE = "SHARE", UNSHARE = "UNSHARE",
    CONTROL = "CONTROL", SYNC = "SYNC",
    PROP_REPORT = "PROP_REPORT", INIT_PROP_REPORT = "INIT_PROP_REPORT",
    TASK_PUBLISH = "TASK_PUBLISH", TASK_CANCEL = "TASK_CANCEL", TASK_RUN = "TASK_RUN"
}

export const deviceMessageTypeZh =
    {
        BIND: "设备绑定",
        UNBIND: "设备解绑",
        ONLINE: "设备上线",
        OFFLINE: "设备下线",
        SHARE: "设备分享",
        UNSHARE: "设备取消分享",
        CONTROL: "设备控制",
        PROP_REPORT: "属性上报",
        INIT_PROP_REPORT: "初始属性上报",
        SYNC: "同步状态",
        TASK_PUBLISH: "任务发布",
        TASK_CANCEL: "任务取消",
        TASK_RUN: "任务执行",
    }

export default class DeviceMessage extends BaseAppModel<DeviceMessage> {
    type!: DeviceMessageType
    level!: MessageLevel
    content!: string
}
